import { LoadGMapsServices } from './maps';

let userLocation: any;

export const getGeolocation = (
  forceRefresh = false
): Promise<google.maps.GeocoderResult> =>
  new Promise((resolve, reject) => {
    if (userLocation && !forceRefresh) resolve(userLocation);

    const success = async (position: Position) => {
      const GMapsServices = await LoadGMapsServices({
        libPath: [],
        libraries: [],
      });

      const latLng = {
        lat: Number(position.coords.latitude),
        lng: Number(position.coords.longitude),
      };

      const geoCoder = new GMapsServices.Geocoder();
      geoCoder.geocode({ location: latLng }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const [address] = results;
          resolve(address);
        } else {
          throw new Error('Error getting the location info.');
        }
      });
    };

    const error = (e: any) => {
      reject(e);
    };

    if (!navigator.geolocation) {
      // TODO: fallback?
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  });

export const getCityFromGeolocation = (
  geolocation: google.maps.GeocoderResult
): string => {
  const stateComponent = geolocation.address_components.find(c =>
    c.types.includes('locality')
  );
  if (!stateComponent) {
    throw new Error('City info does not exist');
  }
  return stateComponent.long_name;
};
